









export default {
  name: "Progress",
  props: {
    progress: {
      type: String,
      default: "0"
    }
  },
};
